import React from 'react';
import ReactDOM from "react-dom";
import ProvidersLocationSearchBar from "../components/providers-location-search-bar/providers-location-search-bar.jsx";
import ElementService from "./services/element-service.js";
import LocationsResultsContainer from "./locations-results-container.js";
import { BREAKPOINTS, FILTER_IDS } from "./constants.js";
import ProvidersResultsContainer from "./providers-results-container.js";

export default class ProvidersLocationsSearchBarContainer {
  constructor() {
    this.elementService = new ElementService();
    this.providersLocationSearchBar = document.querySelector('.field--name-field-find-prov-loc-search-bar');
    this.dumpedLabels = this.providersLocationSearchBar.querySelector('.dumped-labels');
    this.searchPlaceholder = this.dumpedLabels.querySelector('.field--name-field-search-placeholder').textContent;
    this.zipCodePlaceholder = this.dumpedLabels.querySelector('.field--name-field-zip-code-placeholder').textContent;
    this.useMyLocationLabel = this.dumpedLabels.querySelector('.field--name-field-use-my-location-label').textContent;
    this.currentLocationLabel = this.dumpedLabels.querySelector('.field--name-field-current-location-label').textContent;
    this.backLabel = this.dumpedLabels.querySelector('.field--name-field-back-label').textContent;
    this.searchBar = null;
    this.zipCodeInput = null;
    this.storedLocation = null;
    this.clearSearchButton = null;
    this.clearZipButton = null;
    this.searchButton = null;
    this.useCurrentLocationButton = null;
    this.providersTabLink = null;
    this.locationsTabLink = null;
    this.locationsResultsWrapper = document.querySelector('.location-results-grid--wrapper');
    if (this.locationsResultsWrapper) {
      this.locationResultsContainer = this.locationsResultsWrapper.querySelector('.locations-results--container');
    }
    this.providersResultsWrapper = document.querySelector('.provider-results-grid--wrapper');
    if (this.providersResultsWrapper) {
      this.locationsResultsContainer = document.querySelector('.providers-results--container');
    }
    this.zipContainer = null;
    this.currentLocationLatLon = null;
    this.url = null;
    this.onSubmit = this.onSubmit.bind(this);
    this.onSearchClearClick = this.onSearchClearClick.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onZipChange = this.onZipChange.bind(this);
    this.onZipClearClick = this.onZipClearClick.bind(this);
    this.onUseMyLocationClicked = this.onUseMyLocationClicked.bind(this);
    this.onBackClicked = this.onBackClicked.bind(this);
  }

  setListeners() {
    this.zipCodeInput.addEventListener('click', () => {
      if (window.innerWidth < BREAKPOINTS.DESKTOP) {
        this.openMobileZip();
      }
    });

    if (this.providersTabLink) {
      this.providersTabLink.addEventListener('click', event => {
        const providersTabLinkUrl = new URL(this.providersTabLink.href);
        this.addSearchParamsToButtonUrls(providersTabLinkUrl, this.providersTabLink);
      });
    }

    if (this.locationsTabLink) {
      this.locationsTabLink.addEventListener('click', event => {
        const locationsTabLinkUrl = new URL(this.locationsTabLink.href);
        this.addSearchParamsToButtonUrls(locationsTabLinkUrl, this.locationsTabLink);
      });
    }

    if (this.searchButton) {
      this.searchButton.addEventListener('click', event => {
        // reset filter on search button click. Not in onsubmit because that would wipe
        // pre-loaded filters.
        const url = new URL(window.location);
        url.searchParams.delete(FILTER_IDS.SPECIALTY);
        url.searchParams.delete(FILTER_IDS.ONLINE_SCHEDULING_TYPE);
        window.history.pushState({}, '', decodeURIComponent(url));
      })
    }
  }

  addSearchParamsToButtonUrls(originalButtonURL, button) {
    originalButtonURL.searchParams.set(
      FILTER_IDS.SEARCH,
      this.searchBar.value,
    );
    button.href = originalButtonURL;

    if (this.zipCodeInput.value !== this.currentLocationLabel) {
      originalButtonURL.searchParams.set(FILTER_IDS.LOCATION, this.zipCodeInput.value);
      button.href = originalButtonURL;
    }
  }

  closeMobileZip() {
    this.zipContainer.classList.remove('zip-code--active');
    document.querySelector('.site-header').classList.remove('zip-search-bar--mobile-search');
    document.querySelector('body').classList.remove('disable-scroll');
  }

  openMobileZip() {
    this.zipContainer.classList.add('zip-code--active');
    document.querySelector('.site-header').classList.add('zip-search-bar--mobile-search');
    document.querySelector('body').classList.add('disable-scroll');
  }

  onSearchChange() {
    if (this.searchBar.value === "") {
      this.elementService.toggleVisibleStateOfElement(this.clearSearchButton, false);
    } else {
      this.elementService.toggleVisibleStateOfElement(this.clearSearchButton, true);
    }
  }

  onSearchClearClick() {
    this.searchBar.value = null;
    this.elementService.toggleVisibleStateOfElement(this.clearSearchButton, false);
  }

  onZipChange() {
    if (this.zipCodeInput.value === "") {
      this.elementService.toggleVisibleStateOfElement(this.clearZipButton, false);
      this.useCurrentLocationButton.setAttribute('style', 'display:block;');
      // clear zip url params in this was backspaced
      this.onZipClearClick();
    } else {
      this.elementService.toggleVisibleStateOfElement(this.clearZipButton, true);
    }
  }

  onZipClearClick() {
    this.zipCodeInput.value = null;
    this.url.searchParams.delete('userCurrentLatLng');
    this.url.searchParams.delete(FILTER_IDS.LOCATION);
    window.history.pushState({}, '', decodeURIComponent(this.url));
    this.useCurrentLocationButton.setAttribute('style', 'display:block;');
    this.elementService.toggleVisibleStateOfElement(this.clearZipButton, false);
  }

  async showResults() {
    if (this.locationsResultsWrapper) {
      this.loadLocations();
    } else {
      this.loadProviders();
    }
  }

  loadProviders() {
    new ProvidersResultsContainer();
  }

  loadLocations() {
    new LocationsResultsContainer(this.searchBar.value);
  }

  onSubmit(event) {
    event.preventDefault();
    const url = new URL(window.location);
    url.searchParams.set(FILTER_IDS.SEARCH, this.searchBar.value);

    const pageNum = url.searchParams.get(FILTER_IDS.PAGE);
    if (!pageNum) {
      url.searchParams.set(FILTER_IDS.PAGE, 1);
    }

    window.history.pushState({}, '', decodeURIComponent(url));
    this.showResults();
  }

  checkUrlForSearchTerm() {
    const url = new URL(window.location);
    this.searchBar.value = url.searchParams.get(FILTER_IDS.SEARCH);
    if (this.storedLocation) {
      this.useCurrentLocationButton.setAttribute('style', 'display:none;');
    }
    this.searchButton.click();
  }

  checkSessionStorageForCurrentLocation() {
    if (sessionStorage.getItem('userCurrentLatLng')) {
      this.zipCodeInput.value = this.currentLocationLabel;
      this.useCurrentLocationButton.setAttribute('style', 'display:none;');
    }
  }

  onUseMyLocationClicked(event) {
    navigator.geolocation.getCurrentPosition(res => {
      sessionStorage.setItem('userCurrentLatLng', JSON.stringify({
        lat: res.coords.latitude,
        lng: res.coords.longitude,
      }));
      this.zipCodeInput.value = this.currentLocationLabel;
      this.useCurrentLocationButton.setAttribute('style', 'display:none;');
      this.onZipChange();
    }, error => {
      console.error(error);
    });
  }

  onBackClicked(event) {
    this.closeMobileZip();
    this.elementService.toggleVisibleStateOfElement(this.clearZipButton, false);
  }

  initContainer() {
    ReactDOM.render(
      <>
        <ProvidersLocationSearchBar
          key={`providers-location-search-bar`}
          searchPlaceholder={this.searchPlaceholder}
          zipCodePlaceholder={this.zipCodePlaceholder}
          useMyLocationLabel={this.useMyLocationLabel}
          backLabel={this.backLabel}
          onSubmit={this.onSubmit}
          onSearchClearClick={this.onSearchClearClick}
          onSearchChange={this.onSearchChange}
          onZipChange={this.onZipChange}
          onZipClearClick={this.onZipClearClick}
          onUseMyLocationClicked={this.onUseMyLocationClicked}
          onBackClicked={this.onBackClicked}
        />
      </>,
      this.providersLocationSearchBar.querySelector('.find-providers-locations-search-bar--container')
    );
    this.searchBar = this.providersLocationSearchBar.querySelector('#search-bar');
    this.zipCodeInput = this.providersLocationSearchBar.querySelector('#zip-code');
    this.clearSearchButton = this.providersLocationSearchBar.querySelector('.clear-search-button');
    this.clearZipButton = this.providersLocationSearchBar.querySelector('.clear-zip-button');
    this.searchButton = this.providersLocationSearchBar.querySelector('#search-button');
    this.useCurrentLocationButton = this.providersLocationSearchBar.querySelector('#use-current-location');
    this.zipContainer = document.querySelector('.zip-code--label');
    this.providersTabLink = document.getElementById('providers-link');
    this.locationsTabLink = document.getElementById('locations-link');
    this.url = new URL(window.location);
    this.storedLocation = this.url.searchParams.get(FILTER_IDS.LOCATION);
    this.checkSessionStorageForCurrentLocation();
    this.checkUrlForSearchTerm();
    this.setListeners();
  }
}

(async () => {
  if (document.querySelector(
    '.find-providers-locations-search-bar--container',
  )) {
    const providersLocationsSearchBarContainer = new ProvidersLocationsSearchBarContainer();
    await providersLocationsSearchBarContainer.initContainer();
  }
})(Drupal);
